import React, {Component} from "react";
import LayoutHeader from "../Inc/Header";
import { Alert, Spin, Icon } from 'antd';
import AdminNavigation from "../Inc/AdminNavigation";
import EditAlumniRecord from "./EditAlumniRecord";
import QueryBuilder from '../ListandAdvancedSearch/QueryBuilder';
import * as actions from "../../actions/index";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Tabs } from 'antd';
import AddPerson from "./AddPerson";
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;

class RecordRepair extends Component {
    constructor(props) {
      super(props);
      this.state = {
        key: "1",
        cleardata: "",
        PersonGuid:"",
        EditAlumniStatus:false,
        displayTable:"flex"
      }
    }

    componentDidMount = () => {
      let userRole;

      if (this.props.isSuperAlumniAdmin) {
        userRole = "SUPER ADMIN";
      } else if (this.props.isAlumniAdmin) {
        userRole = "ALUMNI ADMIN";
      } else if (this.props.isCSTSupport) {
        userRole = "CST SUPPORT";
      } else if (this.props.isCouncilCommittee) {
        userRole = "COUNCIL COMMITTE";
      } else if (this.props.isspecialist) {
        userRole = "SPECIALIST";
      }

      this.props.actions.getNewReportColumn(userRole); 
      this.props.actions.isadmin();                      
      this.props.actions.getEthnicities();               

      window.scrollTo(0, 0);
    };

    callback = (key, data) => {
      this.setState({ key, cleardata: data });

      if (key == 1 && this.props.match.params.preferencename) {
        this.props.actions.getlist(
          this.props.match.params.preferencename,
          this.props.match.params.listtype
        );
      }
    };

    getPersonGuid = (PersonGuid) =>{
      console.log(PersonGuid)
      this.setState({
        PersonGuid: PersonGuid,
        EditAlumniStatus: true,
        displayTable:"none"
       })
    }

    removeEditAlumni = () =>{ 
      this.setState({
        EditAlumniStatus: !this.state.EditAlumniStatus,
        displayTable:"flex"
       })
    }

    renderTabs = () => {
      if (this.props.loading) {
        return <div className='page-center'>
          <Spin indicator={LoadingIcon} className="loading-state" tip="Loading page..." />
        </div>
      }
  
      
      if (!this.props.error) {
        return <div className='widget-container dashboard-table quick-search query-filter-container'>
          <Tabs activeKey={this.state.key} onChange={this.callback}>
            <TabPane tab="Advanced Search" key="1">
              <QueryBuilder clearValues={this.state.cleardata}  getPersonGuid={this.getPersonGuid} />
            </TabPane>
            <TabPane tab="Add Person" key="2">
              <AddPerson />
            </TabPane>
          </Tabs>
         
        </div>
      }
      if (this.props.error) {
        return <div className='page-center'>
          <Alert
            message={this.props.error.ResponseMessage}
            description="You dont have access to run the report"
            type="error"
            showIcon
          />
        </div>
      }
    }

    render() {

      return (
        <div>
          <LayoutHeader />
          <AdminNavigation />
          <div className='widget' style={{display:this.state.displayTable}}> {this.renderTabs()} </div>
          {(this.state.EditAlumniStatus && this.state.PersonGuid) &&  <EditAlumniRecord PersonGuid={this.state.PersonGuid} removeEditAlumni={this.removeEditAlumni}/>   }
        </div>
      );
    }
}


function mapStateToProps(state) {
  return {
    loading: state.columnlistreducer.loading,
    error: state.columnlistreducer.error,
    preferencelistloading: state.quickpreferencelistreducer.loading,
    preferencelist: state.quickpreferencelistreducer.preferencelist,
    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    isCSTSupport: state.isadminreducer.isCSTSupport,
    isCouncilCommittee: state.isadminreducer.isCouncilCommittee,
    isAlumniAdmin: state.isadminreducer.isAlumniAdmin,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(RecordRepair);


// WEBPACK FOOTER //
// ./src/components/RecordRepair/index.js